import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import { events, on, queryProvider, serviceQueries } from '@estee/elc-service-bus';

const onEvents = [
    [events.REMOVE_ITEM, 'cartItemRemoved'],
    [events.CART_UPDATED, 'cartUpdated'],
    [events.CART_BADGE_CLICKED, 'cartOpened']
];

const queries = [[serviceQueries.GET_MANUAL_OFFER, 'getManualOffer']];

export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                queries.forEach((query) => {
                    try {
                        // @ts-ignore
                        ServiceManager.setDecoratorOnFunction(queryProvider)(query);
                    } catch (e) {
                        console.warn(e);
                    }
                });
                onEvents.forEach((event) => {
                    try {
                        // @ts-ignore
                        ServiceManager.setDecoratorOnFunction(on)(event);
                    } catch (e) {
                        console.warn(e);
                    }
                });
            }
        }, 50);
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
ServiceBusControllerBody;
